import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { AppBar, PageTitle, useLanguageTranslator } from "../../components";
import { Trans } from "react-i18next";
import I18nSelect from "../../components/@common/I18nSelect";

function TermsAndConditions() {
  const { translator } = useLanguageTranslator();
  return (
    <>
      <Box pb={3}>
        <AppBar>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexGrow={1}
          >
            <PageTitle title={translator(`Terms And Conditions`)} subtitle="" />
            <I18nSelect
              options={[
                { label: translator("English"), value: "en" },
                { label: translator("French"), value: "fr" },
                { label: translator("Portuguese"), value: "pt" },
              ]}
            />
            {/* <SearchBar placeholder="Search tree and keyword" /> */}
          </Stack>
        </AppBar>
        <Box sx={{ backgroundColor: "white" }} p={5} borderRadius={"10px"}>
          <Box component="section" sx={{ my: 4 }} px={5}>
            <Typography variant="h5" gutterBottom>
              {translator(`Preamble`)}
            </Typography>

            <Typography paragraph>{translator(`niyel.change`)}</Typography>

            <Typography paragraph>
              {translator("gtu_purpose", {
                gtu: "GTU",
                tracker: "Niyel Tracker",
                we: "We",
                us: "Us",
              })}
            </Typography>

            <Typography paragraph>{translator(`feature one`)}</Typography>

            <Typography paragraph>{translator(`information`)}</Typography>

            <Typography paragraph>{translator(`cover areas`)}</Typography>
          </Box>
          <Box component="section" sx={{ my: 4 }} px={5}>
            <Typography variant="h4" gutterBottom>
              1. {translator(`Definitions`)}
            </Typography>

            <Typography paragraph>
              {translator(
                `In these GCU, words or expressions beginning with a capital letter have the following meaning:`
              )}
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText
                  primary={
                    <>
                      <Trans
                        i18nKey="definitions.account"
                        components={{ strong: <strong />, em: <em /> }}
                      />
                    </>
                  }
                />
              </ListItem>

              <ListItem sx={{ display: "list-item" }}>
                <ListItemText
                  primary={
                    <>
                      <Trans
                        i18nKey="definitions.data"
                        components={{ strong: <strong />, em: <em /> }}
                      />
                    </>
                  }
                />
              </ListItem>

              <ListItem sx={{ display: "list-item" }}>
                <ListItemText
                  primary={
                    <>
                      <Trans
                        i18nKey="definitions.niyelTracker"
                        components={{ strong: <strong />, em: <em /> }}
                      />
                    </>
                  }
                />
              </ListItem>

              <ListItem sx={{ display: "list-item" }}>
                <ListItemText
                  primary={
                    <>
                      <Trans
                        i18nKey="definitions.user"
                        components={{ strong: <strong />, em: <em /> }}
                      />
                    </>
                  }
                />
              </ListItem>
            </List>
          </Box>
          <Divider sx={{ my: 4 }} />
          <Box component="section" sx={{ my: 4 }} px={5}>
            <Typography variant="h5" gutterBottom>
              2. {translator(`Purpose of Niyel Tracker`)}
            </Typography>

            <Typography paragraph>
              {translator(`purpose.onlinetool`)}
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("purpose.trackDecision")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("purpose.frameworks")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("purpose.policy")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator(`purpose.community`)} />
              </ListItem>
            </List>

            <Typography paragraph sx={{ mt: 2 }}>
              {translator(`purpose.institutions`)}
            </Typography>
          </Box>
          <Divider sx={{ my: 4 }} />
          <Box component="section" sx={{ my: 4 }} px={5}>
            <Typography variant="h4" gutterBottom>
              3. {translator(`Acceptance of T&Cs`)}
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.terms")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.subject")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.failure")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.create")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.reserve")} />
              </ListItem>
              <ListItem sx={{ display: "list-item" }}>
                <ListItemText primary={translator("acceptance.clause")} />
              </ListItem>
            </List>
          </Box>
          <Divider sx={{ my: 4 }} />
          <Box component="section" sx={{ my: 4 }} px={5}>
            <Typography variant="h4" gutterBottom>
              4. {translator(`Access to and use of Niyel Tracker`)}
            </Typography>

            <Typography variant="h5" gutterBottom>
              4.1 {translator(`Account creation`)}
            </Typography>

            <Typography paragraph>
              {translator(`account.functionalities`)}
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
              <ListItem sx={{ display: "list-item", fontWeight: 700 }}>
                <ListItemText primary={translator(`account.name`)} />
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 700 }}>
                <ListItemText primary={translator(`account.login`)} />
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 700 }}>
                <ListItemText primary={translator(`account.email`)} />
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 700 }}>
                <ListItemText primary={translator(`account.password`)} />
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 700 }}>
                <ListItemText primary={translator(`account.organization`)} />
              </ListItem>
            </List>

            <Typography
              style={{
                fontWeight: "700",
                paddingBottom: "15px",
                paddingTop: "15px",
              }}
            >
              4.2 {translator(`Responsibility for login parameters`)}
            </Typography>

            <Typography paragraph>{translator(`account.user`)}</Typography>

            <Typography paragraph>{translator(`account.delay`)}</Typography>

            <Typography paragraph>
              {translator(`account.identifiers`)}
            </Typography>

            <Typography paragraph>
              {translator(`account.responsible`)}
            </Typography>

            <Typography paragraph>
              {translator(`account.user.login`)}
            </Typography>

            <Typography paragraph>
              {translator(`account.event.loss`)}
            </Typography>

            <Typography paragraph>
              {translator(`account.user.forget`)}
            </Typography>
          </Box>
          <Box component="section" px={5}>
            <Typography variant="h4" gutterBottom>
              4.3 {translator(`Authorized Use`)}
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
              <Typography paragraph>
                {translator(`authorized.insititutional`)}
              </Typography>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText primary={translator(`authorized.purpose`)} />
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText
                  primary={translator(`authorized.authorization`)}
                />
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText primary={translator(`authorized.automated`)} />
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText primary={translator(`authorized.security`)} />
              </ListItem>
            </List>
          </Box>
          <Divider sx={{ mt: 4 }} />
          <Box sx={{ px: 5, py: 6 }}>
            <Typography variant="h4" gutterBottom>
              5. {translator(`Data and Intellectual Property`)}
            </Typography>

            <Typography variant="h5" gutterBottom>
              5.1 {translator(`Collected Data`)}
            </Typography>
            <Typography paragraph>
              {translator(
                `Niyel Tracker collects and processes the following data`
              )}
              :
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 7 }}>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText
                  primary={translator(
                    "Identification data: surname, first name, e-mail address, organization"
                  )}
                />
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText
                  primary={translator(
                    "Usage data: browsing history, interactions with the platform"
                  )}
                />
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }}
              >
                <ListItemText
                  primary={translator(
                    "Public data: information on policies, decision-makers and practices"
                  )}
                />
              </ListItem>
            </List>
            <Typography paragraph>
              {translator(
                `This data is collected in order to provide a public policy monitoring service and to improve the tool`
              )}
              .
            </Typography>

            <Typography variant="h5" gutterBottom>
              5.2 {translator(`Intellectual Property Rights`)}
            </Typography>
            <Typography paragraph>{translator(`rights.content`)}</Typography>
            <Typography paragraph>{translator(`rights.personal`)}</Typography>
            <Typography paragraph>{translator(`rights.clause`)}</Typography>

            <Divider sx={{ my: 4 }} />

            <Typography variant="h4" gutterBottom>
              6. {translator(`Confidentiality and Data Protection`)}
            </Typography>
            <Typography variant="h5" gutterBottom>
              6.1 {translator(`Data Collection and Processing`)}
            </Typography>
            <Typography paragraph>
              {translator(
                `We are committed to protecting the personal data of Niyel Tracker users.`
              )}
            </Typography>
            <Typography paragraph>{translator(`rights.law`)}</Typography>
            <Typography paragraph>{translator(`rights.rules`)}</Typography>

            <Divider sx={{ my: 4 }} />

            <Typography variant="h4" gutterBottom>
              7. {translator(`Responsibilities`)}
            </Typography>

            <Typography variant="h5" gutterBottom>
              7.1 {translator(`Responsibility of the User`)}
            </Typography>
            <Typography paragraph>
              {translator(`responsibility.responsible`)}
            </Typography>
            <Typography paragraph>
              {translator(`responsibility.access`)}
            </Typography>
            <Typography paragraph>
              {translator(`responsibility.GTC`)}
            </Typography>
            <Typography paragraph>
              {translator(`responsibility.computer`)}
            </Typography>

            <Typography variant="h5" gutterBottom>
              7.2 {translator(`Niyel's Liability`)}
            </Typography>
            <Typography paragraph>{translator(`liability.effort`)}</Typography>
            <Typography paragraph>
              {translator(`liability.improper`)}
            </Typography>

            <Divider sx={{ my: 4 }} />

            <Typography variant="h4" gutterBottom>
              8. {translator(`Modification of the GCU`)}
            </Typography>
            <Typography paragraph>
              {translator(
                `We reserve the right to modify these GCU at any time.`
              )}
            </Typography>
            <Typography paragraph>
              {translator(`modification.notified`)}
            </Typography>

            <Divider sx={{ my: 4 }} />

            <Typography variant="h4" gutterBottom>
              9. {translator(`Applicable Law and Dispute Resolution`)}
            </Typography>
            <Typography paragraph>
              {translator(`These GCU are governed by Senegalese law.`)}
            </Typography>
            <Typography paragraph>
              {translator(`modification.effort`)}
            </Typography>
            <Typography paragraph>
              {translator(`modification.solution`)}
            </Typography>

            <Divider sx={{ my: 4 }} />

            <Typography variant="h4" gutterBottom>
              10. {translator(`Contact`)}
            </Typography>
            <Typography paragraph>{translator(`contact.questions`)}</Typography>

            <Typography variant="h4" gutterBottom>
              {translator(`privacyPolicy`)}
            </Typography>
            <Typography paragraph>
              {translator(`privacy.policy.one`)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export { TermsAndConditions };
